import { render, staticRenderFns } from "./Talent-off.vue?vue&type=template&id=30678627&scoped=true&"
import script from "./Talent-off.vue?vue&type=script&lang=js&"
export * from "./Talent-off.vue?vue&type=script&lang=js&"
import style0 from "./Talent-off.vue?vue&type=style&index=0&id=30678627&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30678627",
  null
  
)

export default component.exports